import styled from 'styled-components';
import * as glx from 'assets/css/glx';

export const BgImg = glx.BgImg;

export const Service = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
`;

export const Title = styled.div`
  font-size: 48px;
  font-family: PingFang SC;
  font-weight: 600;
  color: rgba(254, 254, 254, 1);
  text-shadow: 0px 2px 0px rgba(0, 0, 0, 0.64);
  line-height: 1;
`;

export const SubTitle = styled.div`
  margin-top: 57px;

  font-size: 24px;
  font-family: PingFang SC;
  font-weight: 300;
  color: rgba(254, 254, 254, 1);
  line-height: 1;
`;

export const ServiceContent = styled.div`
  margin-top: 40px;
  position: relative;
`;

export const ContentRow = styled.div`
  display: flex;
  justify-content: center;
  &:not(:last-child) {
    margin-bottom: 46px;
  }
`;

export const ServiceItemLine = styled.div`
  width: 99px;
  height: 1px;
  /* border: 1px solid rgba(0, 255, 255, 1); */
  background-color: rgba(0, 255, 255, 0.3);
`;

export const ServiceItemLineRight = styled(ServiceItemLine)`
  position: absolute;

  top: 50%;
  right: ${props => (props.right ? props.right : 12)}px;
  transform: translateX(100%) translateY(-50%);
`;

export const ServiceItemLineRightDown = styled(ServiceItemLine)`
  position: absolute;

  width: 56px;
  bottom: 0;
  right: 24px;
  transform: translateX(100%) rotateZ(45deg);
  transform-origin: 0 0;
`;

export const ServiceItemLineLeftDown = styled(ServiceItemLine)`
  position: absolute;

  width: 56px;
  bottom: 0;
  right: 24px;
  transform: rotateZ(135deg);
  transform-origin: 0 0;
`;

export const ServiceItem = styled.div`
  text-align: center;
  &:not(:last-child) {
    margin-right: 80px;
  }
`;

export const ItemImgWrapper = styled.div`
  position: relative;
`;

export const ItemImg = styled.img``;

export const ItemText = styled.div`
  position: relative;
  margin-top: 14px;
  font-size: 14px;
  font-family: PingFang SC;
  font-weight: 300;
  color: rgba(254, 254, 254, 1);
  line-height: 1;
`;
